/// <reference types="vite-plugin-svgr/client" />
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { round } from "lodash";

import { useLazySvgImport } from "@/hooks/lazy-svg";
import LightningSvg from "@assets/lightning.svg";

interface BatteryIndicatorProps {
  soc?: number;
  isCharging: number;
}

const BatteryIndicator: React.FC<BatteryIndicatorProps> = ({
  soc,
  isCharging,
}: BatteryIndicatorProps) => {
  const getBatteryIconName = () => {
    if (soc === undefined) return "battery_00";
    if (soc >= 90) return "battery_100";
    if (soc >= 80) return "battery_90";
    if (soc >= 70) return "battery_80";
    if (soc >= 60) return "battery_70";
    if (soc >= 50) return "battery_60";
    if (soc >= 40) return "battery_50";
    if (soc >= 30) return "battery_40";
    if (soc >= 20) return "battery_30";
    if (soc >= 10) return "battery_20";
    if (soc > 0) return "battery_10";
    return "battery_00";
  };

  const { Svg, loading, error } = useLazySvgImport(getBatteryIconName());
  if (loading || error || !Svg) return <></>;

  return (
    <Box
      sx={{
        width: "50%",
        height: "100%",
        visibility: soc === undefined || soc === -1 ? "hidden" : "visible",
      }}
    >
      <Tooltip hidden={soc === undefined} title={round(soc ?? 0) + "%"} sx={{ zIndex: 5 }}>
        <Box sx={{ width: "100%", height: "100%" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              visibility: soc === undefined || soc === -1 ? "hidden" : "visible",
              width: "100%",
              heigh: "100%",
            }}
          >
            <Box
              sx={{
                width: "90%",
                height: "90%",
                mx: "auto",
                borderRadius: "40%",
                position: "relative",
              }}
            >
              <img src={Svg} />
              <img
                style={{
                  position: "absolute",
                  top: 3,
                  left: 0,
                  width: "50%",
                  height: "80%",
                  transform: "translate(50%, 0)",
                  visibility: isCharging === 1 ? "visible" : "hidden",
                }}
                src={LightningSvg}
              />
            </Box>
            <Typography
              sx={{
                mx: "auto",
                fontSize: "calc(0.3rem + 0.7vw)",
                transform: "translate(0,-50%)",
                visibility: soc === undefined || soc === -1 ? "hidden" : "visible",
              }}
            >
              {round(soc ?? 0) + "%"}
            </Typography>
          </Box>
        </Box>
      </Tooltip>
    </Box>
  );
};

export default BatteryIndicator;
